import {MetaTitleDesc} from "./meta";
import DocumentMeta from "react-document-meta";
import {Link} from "react-router-dom";

export default () => {
    const title = 'Инвестиционные проекты Брестской области';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <div><img src={require('./../src/img/InvestmentProjects/cataloginvest.jpg')} /></div>

                    <ul>
                        <li><Link to='/investment-projects/gruszewka'>Спортивно-туристический комплекс Грушевка</Link></li>
                        <li><Link to='/investment-projects/roadside-service-station'>Комплексный пункт придорожного сервиса</Link></li>
                        <li><Link to='/investment-projects/autocamping-brest'>Автокемпинг в г. Бресте на 60 места</Link></li>
                        <li><Link to='/investment-projects/kudriczi'>Этнографический центр д. Кудричи</Link></li>
                        <li><Link to='/investment-projects/hunting-shack'>Охотничий домик</Link></li>
                        <li><Link to='/investment-projects/information-tourist-point'>Справочно-Информационный туристический пункт</Link></li>
                    </ul>
                </div>
            </div>
        </>
    );
}